import {fadeIn, fadeOut} from './fade';

//カレンダー生成
export default class MyLoading {

  constructor(wrapElId) {
		this.el = document.getElementById('js-loading');
	}

	show() {
		fadeIn(null, this.el, 100);
	}

	hide() {
		fadeOut(null, this.el);
	}

	watch() {
		window.addEventListener('loadingStart', (e) => {
			console.log("loadingStart");
			this.show();
		});
		window.addEventListener('loadingEnd', (e) => {
			console.log("loadingEnd");
			this.hide();
		});
	}
}
